export default __webpack_public_path__ + "static/vid3-26fa33a91dc6757f7d56a4543d0ee23b.mp4";